var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToSourceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7266 12.1484L9.35156 7.77344C9.02344 7.41797 8.44922 7.41797 8.12109 7.77344C7.76562 8.10156 7.76562 8.67578 8.12109 9.00391L11.8672 12.75L8.12109 16.5234C7.76562 16.8516 7.76562 17.4258 8.12109 17.7539C8.28516 17.918 8.50391 18 8.75 18C8.96875 18 9.1875 17.918 9.35156 17.7539L13.7266 13.3789C14.082 13.0508 14.082 12.4766 13.7266 12.1484ZM18.9766 12.1484L14.6016 7.77344C14.2734 7.41797 13.6992 7.41797 13.3711 7.77344C13.0156 8.10156 13.0156 8.67578 13.3711 9.00391L17.1172 12.75L13.3711 16.5234C13.0156 16.8516 13.0156 17.4258 13.3711 17.7539C13.5352 17.918 13.7539 18 14 18C14.2188 18 14.4375 17.918 14.6016 17.7539L18.9766 13.3789C19.332 13.0508 19.332 12.4766 18.9766 12.1484Z",
    fill: "#383838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToSourceIcon);
export default __webpack_public_path__ + "static/media/to-source-icon.30e86c18665934c2a14721c1ae7eb13b.svg";
export { ForwardRef as ReactComponent };